import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import { Theme, ListItem, ListItemText, ListItemIcon } from '@mui/material';
import { SatelliteOutlined } from '@mui/icons-material';

import { capitalize } from 'utils';
import { Satellite } from 'models/satellites';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            width: '100%',
            maxWidth: 360,
            paddingRight: theme.spacing(2),
        },
        nested: {
            paddingLeft: theme.spacing(4),
        },
    }),
);

interface ListItemProps {
    satellite: Satellite;
    onClick?: () => void;
}

const SatelliteListItem: React.FunctionComponent<ListItemProps> = ({
    satellite,
    onClick,
}) => {
    const classes = useStyles();

    return (
        <ListItem
            button
            className={classes.root}
            onClick={() => onClick && onClick()}
        >
            <ListItemIcon>
                <SatelliteOutlined
                    style={
                        satellite.enabled
                            ? { color: 'green' }
                            : { color: 'black' }
                    }
                    fontSize="large"
                />
            </ListItemIcon>
            <ListItemText
                primary={satellite.name}
                secondary={`${capitalize(satellite.norad_name)} - ${
                    satellite.catalogue_number
                }`}
            />
        </ListItem>
    );
};

SatelliteListItem.displayName = 'SatelliteListItem';
export default SatelliteListItem;
